import { Component, input, output } from '@angular/core';

import { MapaUf, type EstadoSelecionado } from '@/shared/components/mapa-uf/mapa-uf';

/**
 * Card com a miniatura interativa do mapa do Brasil (mesmo visual do painel de mapa-brasil).
 * Emite `ufChange` com a UF do estado clicado (ou `null` para "Brasil"). Feito para ser colocado
 * como último item do painel de filtros, abaixo dos demais controles.
 */
@Component({
    selector: 'app-mapa-uf-card',
    standalone: true,
    imports: [MapaUf],
    templateUrl: './mapa-uf-card.html',
    styleUrl: './mapa-uf-card.scss'
})
export class MapaUfCard {
    readonly uf = input<string | null>(null);
    readonly ufChange = output<string | null>();

    aoSelecionarNoMapa(estado: EstadoSelecionado | null): void {
        this.ufChange.emit(estado?.uf ?? null);
    }
}
